import React from 'react';
import { Helmet } from 'react-helmet';

export default function PageTitle() {
  return <Helmet title="Trova la casa giusta per te - Casa.it" />;
}